import {CommonService} from '../../services/common.service';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';

@Component({
  templateUrl: './refrigerator-selection-dialog.component.html'
})
export class RefrigeratorSelectionDialogComponent implements OnInit {
  refrigerators: MatTableDataSource<any>;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  selection = new SelectionModel<any>(false, []);
  displayColumns = ['select', 'serial_number', 'material_id', 'material_name', 'batch_name', 'eikastiko_name', 'model_name'];

  constructor(private commonService: CommonService,
              private matDialogRef: MatDialogRef<RefrigeratorSelectionDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    // const tempRefrigerators = [...data.refrigerators, data.refrigerators[0], data.refrigerators[0],data.refrigerators[0]];

    this.refrigerators = new MatTableDataSource<any>(data.refrigerators);

  }

  public ngOnInit(): void {
    this.paginator = this.commonService.setPaginatorTexts(this.paginator);
    this.refrigerators.paginator = this.paginator;
    this.refrigerators.sort = this.sort;
  }

  close(value?) {
    this.matDialogRef.close(value);
  }

  selectRefrigerator() {
    if (this.selection.selected.length === 1) {
      this.close(this.selection.selected[0]);
    } else {
      this.close();
    }
  }

  selectRow1(row: any) {
    const oldSelected = this.selection.selected;
    if (oldSelected.length > 0) {
      this.selection.clear();
      this.selection.toggle(row);
    }
    if (oldSelected[0] === row || oldSelected.length === 0) {
      this.selection.toggle(row);
    }
  }
}
